import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = ["onClick"]

import * as array from '@/lib/array.lib'
import { PersonRmodel } from '@/app.context/workspace/person.rmodel';
import { computed, reactive } from 'vue';
import { TaskRmodel,  } from '@/app.context/workspace/tickets/task.rmodel';
import { blockResolutionString} from '@/app.context/workspace/tickets/tasks/block.rmodel'


export default /*#__PURE__*/_defineComponent({
  __name: 'TaskBlockAssignComponent',
  props: {
    task: {},
    persons: {},
    workableOptionEnabled: { type: Boolean },
    workableInitialValue: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

__expose(
    { 
        data: function () { return { impersonal: data.impersonal, persons: data.persons, workable: data.workable } },
        reset: function () { 
            data.impersonal = true //by default we expect that block goes to some one not from persons
            data.persons.length = 0 //reset blocker menu}
        }
    }
)

const persons_available = computed(()=>{
    
    return props.persons.filter(p=>p != props.task.person)
})

const data:
{
    impersonal: boolean, //means 'anonymous blocker' - the block by person that not in system
    persons: PersonRmodel[],
    workable: boolean

} = reactive({ operation: null, impersonal: false, todo_upcoming: null, persons: [], workable: props.workableInitialValue })


function onBlockerOptionClick(person: PersonRmodel) {

    if (data.persons.length == 0) data.impersonal = false;

    if (data.persons.indexOf(person) >= 0) {

        //get rid of
        array.remove(data.persons, person)

    }
    else data.persons.push(person)
}


function hasUnresolvedBlock (task:TaskRmodel, person:PersonRmodel){

    const b = task.blockOrNull_Model(person)

    if (b == null) return false

    if (b.resolution != null) return false

    return true
}

function blcokResolution(task:TaskRmodel, person:PersonRmodel){

    const b = task.blockOrNull_Model(person)

    if (b == null) return null;

    return b.resolution
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("i", {
        class: "bi bi-person-bounding-box clickable",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (data.impersonal = !data.impersonal))
      }),
      _withDirectives(_createElementVNode("span", null, "[V]", 512), [
        [_vShow, data.impersonal]
      ])
    ]),
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(persons_available.value, (p) => {
        return (_openBlock(), _createElementBlock("div", {
          key: p.name
        }, [
          _createElementVNode("span", {
            class: _normalizeClass({ clickable: !hasUnresolvedBlock(_ctx.task, p) }),
            onClick: ($event: any) => (hasUnresolvedBlock(_ctx.task, p) ? null : onBlockerOptionClick(p))
          }, "@" + _toDisplayString(p.name), 11, _hoisted_1),
          _createTextVNode(),
          _withDirectives(_createElementVNode("span", null, "[V]", 512), [
            [_vShow, data.persons.indexOf(p) >= 0]
          ]),
          _withDirectives(_createElementVNode("span", null, " [blocked]", 512), [
            [_vShow, hasUnresolvedBlock(_ctx.task, p)]
          ]),
          _withDirectives(_createElementVNode("span", null, " [" + _toDisplayString(_unref(blockResolutionString)(blcokResolution(_ctx.task, p)!)) + "]", 513), [
            [_vShow, blcokResolution(_ctx.task, p) != null]
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("span", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.workable) = $event))
        }, null, 512), [
          [_vModelCheckbox, data.workable]
        ]),
        _createTextVNode(" Workable")
      ], 512), [
        [_vShow, _ctx.workableOptionEnabled]
      ])
    ])
  ], 64))
}
}

})